import { SiteConfig } from '@types/index'

export const siteConfig: SiteConfig = {
  title: import.meta.env.VITE_SITE_NAME || 'HammerMUD',
  description: import.meta.env.VITE_SITE_DESCRIPTION || 'Modern MUD Gaming Experience',
  url: import.meta.env.VITE_SITE_URL || 'https://hammermud.com',
  navigation: [
    {
      label: 'Home',
      href: '/'
    },
    {
      label: 'About',
      href: '/about'
    },
    {
      label: 'Features',
      href: '/features'
    },
    {
      label: 'Blog',
      href: '/blog'
    },

    {
      label: 'Support',
      href: '/support'
    }
  ],
  footer: {
    copyright: `© ${new Date().getFullYear()} HammerMUD. All rights reserved.`,
    links: [
      {
        label: 'Privacy Policy',
        href: '/privacy'
      },
      {
        label: 'Terms of Service',
        href: '/terms'
      },
      {
        label: 'Support',
        href: '/support'
      }
    ]
  },
  social: {
    twitter: import.meta.env.VITE_TWITTER_HANDLE,
    github: import.meta.env.VITE_GITHUB_URL,
    discord: 'https://discord.gg/pSZtJccydN',
    patreon: 'https://patreon.com/HammerMUD',
    facebook: import.meta.env.VITE_FACEBOOK_URL
  }
}